var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 73.06 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:#c00;}.cls-2{fill:#fff;stroke:#e30613;stroke-width:0.11px;}.cls-2,.cls-3{stroke-miterlimit:3.86;}.cls-3{stroke:#c00;stroke-width:0.06px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "aco-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 0 22.94 0 22.94 56 0 56 0 0 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6,50.81a9,9,0,0,0-.32,2.5H2.37A22.61,22.61,0,0,1,3,47a23.15,23.15,0,0,1,5.33-9.93,10.57,10.57,0,0,1,3.1-2.79,13.85,13.85,0,0,1,3.32,3.09A24.89,24.89,0,0,1,19.9,47a26,26,0,0,1,.71,6.23H17.25A9.31,9.31,0,0,0,17,50.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.71,47.37h9.47a17.31,17.31,0,0,0-1.63-4.24A16.31,16.31,0,0,0,11.34,39a13.85,13.85,0,0,0-3,3.95,18.88,18.88,0,0,0-1.62,4.39Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "24.96 0 48.06 0 48.06 56 24.96 56 24.96 0 24.96 0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.16,50.24a10.19,10.19,0,0,1-7.84,3.65A9.83,9.83,0,1,1,45.09,38L42.37,40.1a6.25,6.25,0,0,0-5-2.34,6.28,6.28,0,0,0,0,12.55,6.53,6.53,0,0,0,5-2.24L45,50l.18.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "50.08 0 73.06 0 73.06 56 50.08 56 50.08 0 50.08 0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.82,44a9.72,9.72,0,0,1,9.71-9.72A9.85,9.85,0,0,1,71.4,44a10,10,0,0,1-9.87,9.83A9.82,9.82,0,0,1,51.82,44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M55.3,44a6.27,6.27,0,0,1,12.54,0A6.27,6.27,0,1,1,55.3,44Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.926772fc69c7c0008ad3c455d92f9220.svg";
export { ForwardRef as ReactComponent };